import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/config';

export const getDocuments = createAsyncThunk(
  'document/getAll',
  async (filters, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams();
      Object.entries(filters).forEach(([key, value]) => {
        if (value) params.append(key, value);
      });

      const response = await axiosInstance.get(`/api/v1/document?${params}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch documents');
    }
  }
);

export const getDocumentsByTransactionId = createAsyncThunk(
  'document/getByTransactionId',
  async (transactionId, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/api/v1/document/transaction/${transactionId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch documents');
    }
  }
);

const documentSlice = createSlice({
  name: 'document',
  initialState: {
    documents: [],
    loading: false,
    error: null
  },
  reducers: {
    clearDocuments: (state) => {
      state.documents = [];
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDocuments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDocuments.fulfilled, (state, action) => {
        state.loading = false;
        state.documents = action.payload.documents;
      })
      .addCase(getDocuments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getDocumentsByTransactionId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDocumentsByTransactionId.fulfilled, (state, action) => {
        state.loading = false;
        state.documents = action.payload.documents;
      })
      .addCase(getDocumentsByTransactionId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { clearDocuments } = documentSlice.actions;
export default documentSlice.reducer;